import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { store } from "../../store/store";

import { extendAddressDataList, extendLocationData } from "../../utils/services/ExtendedDataUtils";
import { DeleteUserAddress, getUserSavedAddress } from "../../utils/services/user/UserAddressUtils";
import { ScreenPushBackData, UserSavedAddressSubscription } from "../../utils/services/subject-behaviour/CommonRxjsService";

import { CommonZeroScreen } from "../zero-screens/CommonZeroScreen";
import { SecondaryCTA, PrimaryCTA } from "../../utils/widgets/CommonCTA";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { AddressInfoView } from "../../utils/widgets/Location/Location-Widget";

import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";
import { ScreenPushBackCode } from "../../utils/constants/SubjectBehaviousConstant";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import disableScroll from "disable-scroll"

import ActionPopup from "../../utils/modals/ActionPopup";
import ModalContent from "../../utils/constants/ModalContentConstant";

const UserAddressList = (props) => {

    const [userSavedLocation, updateSavedLocation] = useState([])

    const [selectedAddress, setSelectedAddress] = useState({})
    const [deleteAddressPopup, setDeleteAddresPopup] = useState(false)

    useEffect(() => {
        const reduxState = store.getState()
        if (reduxState.isUserLogin) {
            UserSavedAddressSubscription.getSavedAddress().subscribe((addressData) => {
                if (reduxState.isUserLogin) {
                    if (addressData['hasFetched']) {
                        updateSavedLocation(addressData['addressList'] ?? [])
                    } else getUserSavedAddress()
                }
            })
        }
        ScreenPushBackData.getPushBackData().subscribe((data: any) => {
            if (data['pushBackCode'] == ScreenPushBackCode.savedLocationForAddList) {
                let updatedLocation = extendAddressDataList(
                    data['pushBackData']['addressList'])[0]
                let updatedIndex = 0
                userSavedLocation.forEach((location: any, index) => {
                    if (location['aid'] == updatedLocation['aid'])
                        updatedIndex = index
                })
                userSavedLocation.splice(updatedIndex, updatedIndex, updatedLocation)
                updateSavedLocation(userSavedLocation)
                UserSavedAddressSubscription.setSavedAddress({
                    hasFetched: true,
                    addressList: data['pushBackData']['addressList']
                })
                ScreenPushBackData.clearPushBackData()
            }
        })
    }, [])

    const onEditAddress = (location) => {
        props.navigation.navigate(ScreenRoute.upsert_user_address, {
            selectedLocation: extendLocationData(location, {}),
            isEditAddress: true
        })
    }


    const showDeleteAddressPopup = () => {
        // disableScroll.on()
        setDeleteAddresPopup(true)
    }

    const closeDeleteAddressPopup = () => {
        disableScroll.off()
        setDeleteAddresPopup(false)
    }

    return (
        <View>

            <CommonHeader title={'Manage Your Addresses'} navigation={props.navigation} />

            <View style={[{
                paddingVertical: 16, paddingHorizontal: 16,
                marginTop: AppTheme.headerHeight, marginBottom: AppTheme.bottomFixButton
            }]}>
                {userSavedLocation.length > 0 ?
                    userSavedLocation.map((address) => (
                        <View key={address['aid']}
                            style={[AppStyles.borderView , AppStyles.bgWhite, AppStyles.p16, AppStyles.mb16, {
                                paddingHorizontal: 16,
                                paddingVertical: 16,
                                marginBottom: 16
                            }]}>
                            <AddressInfoView location={address} />
                            <View style={[AppStyles.flexRowCenter, { marginTop: 16 }]}>
                                <SecondaryCTA
                                    text={'Edit'}
                                    width={AppTheme.appWidth / 2 - 40}
                                    paddingVertical={8}
                                    onPress={() => { onEditAddress(address) }}
                                />
                                <View style={{ width: 16 }} />
                                <SecondaryCTA
                                    text={'Delete'}
                                    width={AppTheme.appWidth / 2 - 40}
                                    paddingVertical={8}
                                    borderColor={AppTheme.color.red.highlight}
                                    textColor={AppTheme.color.red.highlight}
                                    action={() => {
                                        setSelectedAddress(address);
                                        showDeleteAddressPopup()
                                    }}
                                />
                            </View>
                        </View>
                    )) : <CommonZeroScreen screenName={'noSavedAddress'} />
                }
            </View>

            <View style={[AppStyles.bottomFix, AppStyles.mediumShadow,
            AppStyles.bgWhite, { padding: 16 }]}>
                <PrimaryCTA text={'Add New Address'}
                    onPress={() => { props.navigation.navigate(ScreenRoute.upsert_user_address) }} />
            </View>

            <ActionPopup showPopup={deleteAddressPopup}
                modalData={ModalContent.DeleteAddress}
                closeModal={closeDeleteAddressPopup}
                primaryAction={() => DeleteUserAddress(selectedAddress, updateSavedLocation)} />
        </View>
    )
}

export default UserAddressList